import { styled } from 'styled-components';

export const ContentWrapper = styled.section`
  font-size: var(--font-lg);
  padding: var(--spacing-medium) var(--spacing-medium) var(--spacing-huge);
`;
